<template>
  <div id="app">
    <router-view />
    <!-- 底部导航栏 -->
    <tab-bar v-if="$route.meta.showTabBar" />
  </div>
</template>
<script>
import TabBar from '@/components/bottom_tabs.vue'
export default {
  name: 'App',
  components: {
    TabBar
  }
}
</script>
<style lang="less">
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
/* structural elements 结构元素 */
dl,
dt,
dd,
ul,
ol,
li,
/* list elements 列表元素 */
pre,
/* text formatting elements 文本格式元素 */
fieldset,
lengend,
button,
input,
textarea,
/* form elements 表单元素 */
th,
td {
  /* table elements 表格元素 */
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
